export default {
	rebateTypeText: function (product) {
		var t = this.site.productType.filter(e => e.name === product.mission_type);
		return  t.length ? t[0].text : this.site.productType[0].text;
	}
	, rebatee: {
		name: "rebatee"
		, productType: [
			{name: "PopularRebates", text: "Popular Rebates"},
			{name: "YouTubeReview", text: "Youtube Review"}, {name: "YouTubeRelated", text: "Youtube Related"}
		]
	}
	, suv: {
		name: "suv"
		, productType: [
			{name: "Surveys", text: "Surveys"},
			{name: "YouTubeReview", text: "Unboxing Videos"}, {name: "UnboxingAndAmzVideoReview", text: "Unboxing+Amz Video Reviews"}
		]
	}
};


// WEBPACK FOOTER //
// ./src/session.js